import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

interface PromptLabelConfigurationResponse {
  success: boolean;
  is_protected: boolean;
  approver_role_id: number | null;
}

export const usePromptLabelConfiguration = (labelId: number | null | undefined, enabled = true) => {
  const userToken = useUserToken();

  return useQuery<PromptLabelConfigurationResponse>({
    queryKey: ["prompt-label-configuration", labelId],
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.prompt_label_configuration(labelId!), {
        method: "GET",
        headers: authHeader(userToken),
      });
      return handleResponse(response);
    },
    enabled: enabled && !!labelId && !!userToken,
  });
};
